import { MouseEvent, useCallback } from 'react';
import { getHoverState } from '@components/MainStage/hover.store';

const EDGE_SELECTOR = '.react-flow__edge';
const NODE_SELECTOR = '.react-flow__node';

const useHoverPointerReset = () => {
  const onMouseOver = useCallback(({ target }: MouseEvent) => {
    const element = target instanceof Element ? target : null;
    const { setHovered, setHoveredEdge } = getHoverState();

    if (!element?.closest(EDGE_SELECTOR)) setHoveredEdge(null);
    if (!element?.closest(NODE_SELECTOR)) setHovered(null);
  }, []);

  const onMouseLeave = useCallback(() => {
    const { setHovered, setHoveredEdge } = getHoverState();

    setHoveredEdge(null);
    setHovered(null);
  }, []);

  return { onMouseOver, onMouseLeave };
};

export default useHoverPointerReset;
